export default "__VITE_ASSET__BtVTYOqZ__"